import React, { useState, useEffect } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody, MDBContainer } from 'mdb-react-ui-kit';
import { Row, Col, Container, Button, } from 'react-bootstrap';
import '../../index.css';
import Navbar from '../../components/common/Navbar';
import apiService from '../../services/api.services';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs';

const PreloadingList = () => {

    const [error, setError] = useState(null);

    useEffect(() => {
        const JWTtoken = window.sessionStorage.getItem('token')
        apiService.preloadingLogs(JWTtoken)
            .then(response => {
                console.log(':::::Array of Preloading Log Records:::::')
                setAllRows(response.data);

            })
            .catch(error => {
                setError(error);
            });
            apiService.excelPreloadingList(JWTtoken)
            .then(response => {
                console.log(':::::Array of Preloading Log Received for Excel export:::::')
                setexcelData(response.data);

            })
            .catch(error => {
                setError(error);
            });
    }, []);

    const [allRows, setAllRows] = useState([]);
    const [excelData, setexcelData] = useState([]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10; // Number of rows per page

    // Calculate total pages
    const totalPages = Math.ceil(allRows.length / rowsPerPage);

    // Calculate the rows to display on the current page
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allRows.slice(indexOfFirstRow, indexOfLastRow);
    
    const pageGroupSize = 5;
    const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
    const startPage = currentGroup * pageGroupSize + 1;
    const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const exportExcel = () => {
        // toast.success('Hitttt hogya');

        // Updated header array
        const header = [
            "Form Id", "Customer Name", "Salesperson Name", "CRM Number", "Preloading Reason", "Approval Request Date", "OEM",
            "Opportunity Name", "Customer Confirmation", "Expected Time(in Days) to get the final PO from Customer",
            "Customer Credit Period for this Deal (in Days)", "Expected Days of Delivery of Product from Vendor",
            "Vendor Credit Period for this Deal (in Days)", "Vendor Billing Cycle", "Selling Value (IN INR)",
            "Purchase Value (IN INR)", "Margin (IN INR)", "Expected PO Date (Calculated)",
            "Expert advice from Company's Cashflow Prospective", "Expert advice from Company's Margin Prospective",
            "Customer PO Receiving Date", "Actual Margin % at the time of CRM Won"
        ];

        // Create a new workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Data');

        // Add header row
        worksheet.addRow(header);

        // Apply styles to the header row (first row)
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: 'FFFFFF' } }; // White bold font
        headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '808080' } }; // Gray background
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };

        // Add data rows (your allRows data)
        excelData.forEach(row => {
            worksheet.addRow(Object.values(row));
        });

        // Adjust column widths dynamically based on header length (or content)
        header.forEach((column, index) => {
            const maxLength = Math.max(column.length, ...excelData.map(row => String(Object.values(row)[index]).length));
            worksheet.getColumn(index + 1).width = maxLength + 2; // Add some padding
        });

        // Apply borders to the entire table (all cells in the worksheet)
        const totalRows = worksheet.rowCount;
        const totalCols = header.length;

        for (let row = 1; row <= totalRows; row++) {
            for (let col = 1; col <= totalCols; col++) {
                const cell = worksheet.getCell(row, col);
                cell.border = {
                    top: { style: 'thin', color: { argb: '000000' } },    // Black top border
                    left: { style: 'thin', color: { argb: '000000' } },   // Black left border
                    bottom: { style: 'thin', color: { argb: '000000' } }, // Black bottom border
                    right: { style: 'thin', color: { argb: '000000' } }   // Black right border
                };
            }
        }

        // Create a buffer and export the Excel file
        workbook.xlsx.writeBuffer().then(buffer => {
            const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(data, 'Final Preloading.xlsx');  // Use FileSaver to save the file
        });
    };


    if (error) return <h1>Error: {error.message}</h1>;
    return (
        <>
            <Navbar />
            {/* <h1 className='headerRibbon'>Preloading Logs</h1> */}

             <style>
        {`
          /* TR styling */
          .expandable-row {
            transition: background-color 0.3s ease;
          }

          .expandable-row:hover {
            background-color: #f9f9f9;
          }

          /* TD styling */
          .expandable-cell {
            padding: 0;
            margin: 0;
            border: none;
          }

          /* Inner wrapper for animation */
          .cell-wrapper {
            max-height: 30px;
            overflow: hidden;
            transition: max-height 0.4s ease;
            padding: 10px;
          }

          .expandable-row:hover .cell-wrapper {
            max-height: 500px;
          }
        `}
      </style>

            <Container className="pt-3 mb-2">
                <Row className="justify-content-between">
                    <Col md="auto">

                    </Col>
                    <Col md="auto">
                        <h1>Preloading List</h1>
                        {/* <Button variant="success" onClick={openNewForm}>New +</Button> */}
                    </Col>
                    <Col md="auto">
                        <Button variant="success" onClick={exportExcel}>EXPORT</Button>
                    </Col>
                </Row>
            </Container>
            <MDBContainer fluid style={{ justifyItems: 'center' }}>
                <div style={styles.tableWrapper}>
                    <MDBTable align='middle' bordered hover small>
                        <MDBTableHead className='table-dark sticky-header'>
                            <tr>
                                {/* <th scope='col' ></th> */}
                                <th scope='col' >Form Id</th>
                                <th scope='col' >Customer Name</th>
                                <th scope='col' >Salesperson Name</th>
                                <th scope='col' >CRM Number</th>
                                <th scope='col' >Preloading Reason</th>
                                <th scope='col' >Approval Request Date</th>
                                <th scope='col' >OEM</th>
                                <th scope='col' >Opportunity Name</th>
                                <th scope='col' >Customer Confirmation</th>
                                <th scope='col' >Expected Time(in Days) to get the final PO from Customer</th>
                                <th scope='col' >Customer Credit Period for this Deal (in Days)</th>
                                <th scope='col' >Expected Days of Delivery of Product from Vendor</th>
                                <th scope='col' >Vendor Credit Period for this Deal (in Days)</th>
                                <th scope='col' >Vendor Billing Cycle</th>
                                <th scope='col' >Selling Value (IN INR)</th>
                                <th scope='col' >Purchase Value (IN INR)</th>
                                <th scope='col' >Margin (IN INR)</th>
                                <th scope='col' >Margin %</th>
                                <th scope='col' >Expected PO Date (Calculated)</th>
                                <th scope='col' >Expert advice from Company's Cashflow Prospective</th>
                                <th scope='col' >Expert advice from Company's Margin Prospective</th>
                                <th scope='col' >Customer PO Receiving Date</th>
                                <th scope='col' >Actual Margin % at the time of CRM Won</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {currentRows.map((row, index) => (
                                <tr key={index} className="expandable-row" >
                                    {/* <th scope='row'></th> */}
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.formSeries}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.customerName}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.salesPersonName}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.crmNumber}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.reasonToLoadOrderAsPreloading}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.approvalRequestDate}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.OEM}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.opportunityName}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.customerConfirmation}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.expectedTimeInDaysToGetFinalPOFromCustomer}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.customerCreditPeriodForThisDealInDays}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.expectedDaysOfDeliveryOfProductFromVendor}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.vendorCreditPeriodForThisDealInDays}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.vendorBillingCycle}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.sellingValueTotal}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.purchaseValueTotal}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.marginYearTotal}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.marginPercentage}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.expectedPoDate}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.expertAdviceCashflow}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.expertAdviceMargin}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.confirmedPODate}</p>
                                    </td>
                                    <td className="expandable-cell">
                                        <p className='text-muted mb-0 cell-wrapper'>{row.actualMarginCrmWon}</p>
                                    </td>
                                </tr>
                            ))}
                        </MDBTableBody>
                    </MDBTable>
                </div>

                {/* Pagination Controls */}
                {/* <div style={styles.pagination}>
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </button>
                    {[...Array(totalPages).keys()].map((number) => (
                        <button
                            key={number}
                            style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
                            onClick={() => handlePageChange(number + 1)}
                        >
                            {number + 1}
                        </button>
                    ))}
                    <button
                        style={styles.pageButton}
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </button>
                </div> */}

                <div style={styles.pagination}>
            <button
                style={styles.pageButton}
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
            >
                Previous
            </button>

            {startPage > 1 && (
                <>
                    <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
                    <span style={styles.ellipsis}>...</span>
                </>
            )}

            {[...Array(endPage - startPage + 1).keys()].map((index) => {
                const pageNum = startPage + index;
                return (
                    <button
                        key={pageNum}
                        style={{
                            ...styles.pageButton,
                            ...(pageNum === currentPage ? styles.activePageButton : {}),
                        }}
                        onClick={() => handlePageChange(pageNum)}
                    >
                        {pageNum}
                    </button>
                );
            })}

            {endPage < totalPages && (
                <>
                    <span style={styles.ellipsis}>...</span>
                    <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                </>
            )}

            <button
                style={styles.pageButton}
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
            >
                Next
            </button>
        </div>

            </MDBContainer>
        </>
    );
};

// Inline CSS for the component
// const styles = {
//     tableWrapper: {
//         maxWidth: '90%',
//         overflowX: 'auto', // Enable horizontal scrolling
//         overflowY: 'auto', // Enable vertical scrolling
//         maxHeight: '590px', // Adjust the height to fit your needs
//         marginBottom: '10px',
//     },
//     // stickyHeaderStyle: {
//     //     position: 'sticky',
//     //     top: 0,
//     //     background: 'white',
//     //     zIndex: 1,
//     // },
//     pagination: {
//         display: 'flex',
//         justifyContent: 'center',
//         gap: '5px',
//     },
//     pageButton: {
//         backgroundColor: '#007bff',
//         color: 'white',
//         border: 'none',
//         borderRadius: '4px',
//         padding: '5px 10px',
//         cursor: 'pointer',
//         outline: 'none',
//     },
//     activePageButton: {
//         backgroundColor: '#0056b3',
//     },
// };

const styles = {
        tableWrapper: {
            maxWidth: '95%',
            overflowX: 'auto', // Enable horizontal scrolling
            overflowY: 'auto', // Enable vertical scrolling
            maxHeight: '450px', // Adjust the height to fit your needs
            marginBottom: '10px',
        },
        pagination: {
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            flexWrap: 'wrap',
            marginTop: '1rem',
        },
        pageButton: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            cursor: 'pointer',
            outline: 'none',
        },
        activePageButton: {
            backgroundColor: '#0056b3',
        },
        ellipsis: {
            padding: '5px 10px',
            color: '#555',
        },
    };

// CSS styles
const stickyHeaderStyles = `
.sticky-header th {
    position: sticky;
    top: 0;
    z-index: 10; // Ensures the header is on top
    background-color: #343a40; // Match the table header color
    color: white; // Text color for header
}
`;

// Add the sticky header styles to the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = stickyHeaderStyles;
document.head.appendChild(styleSheet);


export default PreloadingList;

